<template>
  <Can action="view" subject="package">
    <div data-component-group="package-dialog" data-component="edit">
      <dialog-edit
        icon="layers"
        :copy-link="`/packages/${activePackage?.id}`"
        :title="activePackage.name"
        content-class="edit-label-dialog"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-package-edit
            :package-item="activePackage"
            :is-loading="isEditingPackage"
            :on-cancel="onCancel"
            :on-submit="$ability.can('update', 'package') ? updatePackage : undefined"
          />
        </template>
      </dialog-edit>
    </div>
  </Can>
</template>

<script>
  export default {
    emits: ['saved'],
    data() {
      return {
        isEditingPackage: false,
      };
    },
    created() {
      if (!this.activePackage?.id) {
        this.$store.dispatch('packages/getItem', { id: this.$route.params.id });
      }
    },
    computed: {
      activePackage() {
        return this.$store.getters['packages/activeItem'];
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'packages', query: this.$route.query });
      },
      updatePackage(packageItem) {
        const nextPackageItem = {
          ...packageItem,
          id: this.activePackage.id,
        };

        this.isEditingPackage = true;

        return this.$store
          .dispatch('packages/update', nextPackageItem)
          .then((res) => {
            this.$emit('saved');
            this.$router.push({ name: 'packages', query: this.$route.query });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isEditingPackage = false;
          });
      },
    },
  };
</script>
